import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { Sentry } from './lib/sentry.ts';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="p-8 text-center text-white font-sans bg-slate-900 rounded-xl m-4">An unexpected error occurred. Our team has been notified automatically via Sentry.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
